import AnimationManager from "./AnimationManager";

const MAX_SPEED = 250;

type InertiaConfig = {
  startAngle: number;
  speed: number;
  transform: string;
  snapTo: (angle: number) => number;
};

type Speed = {
  direction: number;
  value: number;
};

function normalizedSpeed(speed: number) : number {
  return Math.max(0, Math.min(1,
    Math.log(Math.abs(speed)) / Math.log(MAX_SPEED))
  );
}

export default class Inertia {
  private startAngle: number;
  private finalAngle: number;
  private speed: Speed;
  private transform: string;

  private animation: Animation;

  constructor(target: HTMLElement, config: InertiaConfig) {
    this.startAngle = config.startAngle;
    if (config.speed === 0) return;

    this.speed = this.getSpeed(config.speed);
    this.finalAngle = this.getFinalAngle(config.snapTo);
    this.transform = config.transform;

    const animation = [
      { transform: `${this.transform} rotateZ(${this.startAngle}deg)` },
      this.getBounceKeyframe(4, 0.25, 0.5),
      this.getBounceKeyframe(-2, 0.55, 0.3),
      this.getBounceKeyframe(1, 0.75, 0.15),
      this.getBounceKeyframe(-0.5, 0.95, 0),
      { transform: `${this.transform} rotateZ(${this.finalAngle}deg)` },
    ];

    const animationConfig = this.getAnimationConfig();

    this.animation = target.animate(animation, animationConfig);
  }

  public stop(): void {
    if (this.animation) {
      AnimationManager.commintAndStop(this.animation);
    }
  }

  private getAnimationConfig(): KeyframeAnimationOptions {
    return {
      duration: this.speed.value * 3000,
      fill: "forwards",
      iterations: 1,
    };
  }

  private getBounceKeyframe(
    bounceFactor: number,
    offset: number,
    offsetFactor: number
  ): Keyframe {
    const angle = this.finalAngle + bounceFactor * this.speed.value;
    return {
      transform: `${this.transform} rotateZ(${angle}deg)`,
      offset: offset + offsetFactor * this.speed.value,
    };
  }

  private getFinalAngle(snapTo: (x: number) => number): number {
    const realSpeed = this.speed.value * this.speed.direction;
    return snapTo(this.startAngle + realSpeed * 45);
  }
  
  private getSpeed(speed: number): Speed {
    return {
      direction: Math.sign(speed),
      value: normalizedSpeed(speed),
    };
  }
}
